$(document).on("turbolinks:load", function () {
  const $body = $("body")
  if (!$body.hasClass("layout-carts-checkout")) return

  $(".js-stripe-checkout-btn").on("click", function (e) {
    e.preventDefault()
    showLoading()
    initializeStripeCheckout()
  })

  async function initializeStripeCheckout() {
    const stripe = window.Stripe(window.stripePK)

    const response = await fetch("/create-stripe-checkout-session", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "content-type": "application/json",
        "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content"),
      },
      body: JSON.stringify({
        coupon_id: $("#coupon_id").val(),
      }),
    })

    const data = await response.json()
    console.log(data)

    if (data["success"] === true) {
      // Initialize checkout session form
      const clientSecret = data["clientSecret"]
      const checkout = await stripe.initEmbeddedCheckout({
        clientSecret,
      })

      $(window).one("beforeunload", showLoading)

      // Mount checkout
      checkout.mount("#stripe_checkout")
      // Hidden, not removed: PayPal's SDK may still be rendering its message into it.
      $("#js-payment-buttons").addClass("d-none")
      $(".js-discount-box").remove()
      $(".js-stripe-checkout-wrapper").removeClass("d-none")
      hideLoading()
    } else {
      // Error handling
      swal({
        title: "Uh Oh!",
        text: "Checkout could not be started.\n\n" + data["error"],
        icon: "warning",
        buttons: {
          confirm: {
            text: "OK",
            value: true,
            visible: true,
            className: "",
            closeModal: true,
          },
        },
      }).then(function () {
        location.reload()
      })
    }
  }

  function showLoading() {
    $body.addClass("loading")
    $body.prepend('<div class="loading-messages">Please wait ...</div>')
  }

  function hideLoading() {
    $body.removeClass("loading")
    $(".loading-messages").remove()
  }
})
